import React, { useState } from "react";
import { connect } from "react-redux";
import styles from "./ComentariosProyectos.module.scss";
import { getProjectQuestions } from "../../../store/actions/profileActions";

const ComentariosProyectos = ({
  projectId,
  questions,
  getProjectQuestions,
}) => {
  const [question, setQuestion] = useState("");

  const submitHandler = (projectId, question) => {
    getProjectQuestions(projectId, question);
    setQuestion("");
  };

  return (
    <div className={styles.containerWrapper}>
      <div className={styles.formGroup}>
        <div className={styles.border}>
          <input
            placeholder="Añade un comentario"
            type="text"
            className={styles.searchInput}
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
          />
          <button
            disabled={question.length < 3}
            type="submit"
            className={styles.active}
            onClick={() => submitHandler()}
          >
            Comentar
          </button>
        </div>
        {question.length > 255 ? (
          <p className={styles.warning}>Supero los 255 caracteres</p>
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    questions: state.profile.questions,
    projectId: state.dashboard.allProjects.entities,
  };
};

export default connect(mapStateToProps, { getProjectQuestions })(
  ComentariosProyectos
);
